import { render, staticRenderFns } from "./ExampleDescription.vue?vue&type=template&id=7dc42536&scoped=true"
import script from "./ExampleDescription.vue?vue&type=script&lang=js"
export * from "./ExampleDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc42536",
  null
  
)

export default component.exports